var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 0L6.73483 3.80041H10.7308L7.49799 6.14919L8.73282 9.94959L5.5 7.60081L2.26718 9.94959L3.50201 6.14919L0.269189 3.80041H4.26517L5.5 0Z","fill":"#FFBA22"}));
}

Star.defaultProps = {"width":"11","height":"10","viewBox":"0 0 11 10","fill":"none"};

module.exports = Star;

Star.default = Star;
